module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContractInfoBox),
      expression: "showContractInfoBox"
    }],
    staticClass: "fade"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContractInfoBox),
      expression: "showContractInfoBox"
    }],
    staticClass: "succ-pop",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "mint-msgbox-wrapper",
    staticStyle: {
      "position": "absolute",
      "z-index": "100"
    }
  }, [_c('div', {
    staticClass: "mint-msgbox"
  }, [_c('div', {
    staticClass: "main-2_z"
  }, [_c('div', {
    staticClass: "main2-title layer-fixed clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "15px",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "float": "left",
      "text-align": "right",
      "color": "#0a8ddf"
    },
    on: {
      "click": function($event) {
        return _vm.actionHandler('cancel')
      }
    }
  }, [_c('span', [_vm._v("关闭")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "xinxi",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("\n                  合同名称： " + _vm._s(_vm.contractInfo.contractName) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同编号：    " + _vm._s(_vm.contractInfo.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("线下合同编号：" + _vm._s(_vm.contractInfo.contractNoOffline))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同金额：    " + _vm._s(_vm.contractInfo.contractMoney))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("付款方式： " + _vm._s(_vm.contractInfo.payTypeString))]), _vm._v(" "), ((_vm.type === '交付明细' && _vm.selected === '累计') || _vm.selected === '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  合同是否结清账款：   " + _vm._s(_vm.contractInfo.isSettledString) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.type === '交付明细' && _vm.selected === '累计') || _vm.selected === '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  未结清账款金额：   " + _vm._s(_vm.contractInfo.notSettledMoneySum) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("业务员：    " + _vm._s(_vm.contractInfo.employeeName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("签署客户名称：   " + _vm._s(_vm.contractInfo.signedCustomerName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("签署客户单位：   " + _vm._s(_vm.contractInfo.signedEnterpriseName))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("合同启动日期：   " + _vm._s(_vm.contractInfo.contractStartDT))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("生产状态：   " + _vm._s(_vm.contractInfo.produceStatusString))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("预计生产完结日期：   " + _vm._s(_vm.contractInfo.expectedProduceEndDT))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("发货状态：    " + _vm._s(_vm.contractInfo.deliveryStatusString))]), _vm._v(" "), _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("发货日期：    " + _vm._s(_vm.contractInfo.deliveryDT))]), _vm._v(" "), (_vm.type === '消费明细' && _vm.selected !== '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  待收账户余额 ：    " + _vm._s(_vm.contractInfo.waitPrepayAmount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.type === '交付明细' && _vm.selected !== '个人') ? _c('div', {
    staticClass: "xinxi"
  }, [_vm._v("\n                  待收尾款 ：    " + _vm._s(_vm.contractInfo.waitRetainage) + "\n                ")]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df647602","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyAccountChecked/ContractInfoBox.vue
// module id = 1733
// module chunks = 8